import { render, staticRenderFns } from "./Layoutpage.vue?vue&type=template&id=7f96d42c&scoped=true"
import script from "./Layoutpage.vue?vue&type=script&lang=js"
export * from "./Layoutpage.vue?vue&type=script&lang=js"
import style0 from "./Layoutpage.vue?vue&type=style&index=0&id=7f96d42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f96d42c",
  null
  
)

export default component.exports